import { get, isString, isFunction, isPlainObject, isArray, slice, transform } from 'lodash';

const generateThemeInterface = (strOrArrOrObj, ...expressions) => {
  if (isPlainObject(strOrArrOrObj)) {
    const basePath = strOrArrOrObj.basePath || '';

    return (strings, ...expressions) => {
      if (isPlainObject(strings)) {
        return undefined;
      } // cannot pass another object
      if (isString(strings)) {
        return generateThemeInterface(`${basePath}.${strings}`, ...expressions);
      }
      if (isArray(strings)) {
        return generateThemeInterface([`${basePath}.${strings[0]}`, ...slice(strings, 1)], ...expressions);
      }
    };
  }

  if (isString(strOrArrOrObj)) {
    return (props) => get(props.theme, strOrArrOrObj);
  }

  const getPath = (props) =>
    transform(
      expressions,
      (result, funcOrString, index) => result.push((isFunction(funcOrString) ? funcOrString(props) : props[funcOrString]) + strOrArrOrObj[index + 1]),
      [strOrArrOrObj[0]]
    ).join('');

  const propsFunc = (props) => get(props.theme, getPath(props));

  Object.assign(propsFunc, {});

  return propsFunc;
};

export default generateThemeInterface;
